import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TenureObj } from 'src/app/Core/interfaces/offers-model';


@Component({
  selector: 'app-installment-options',
  templateUrl: './installment-options.component.html',
  styleUrls: ['./installment-options.component.scss']
})
export class InstallmentOptionsComponent implements OnChanges {
  @Input() tenures! : TenureObj[]; 
  @Input() selectedTenure? : number;
  @Output() tenureValueChange = new EventEmitter<any>();
  fullLength : number = this.tenures?.length;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tenures']) {
      this.fullLength = this.tenures?.length;
    }
  }

  constructor(){
    console.log(this.tenures)
  }

  tenuresToShow : number = 6;

  tenureChanged(){
    let tenure = this.tenures.find(option => option.Tenure === this.selectedTenure);
    this.tenureValueChange.emit(tenure);
  }

  showAllTenures() {
    this.tenuresToShow = this.fullLength;
  }

}
